// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"SearchArea-primaryButton-wcC_8b","appSearch":"SearchArea-appSearch-3py5tn"};